$(document).ready(function() {
    // owl-banner
  $(".faqsecCaro").owlCarousel({ 
      items: 1,  
      nav: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:3300,
  	});
    var owl = $('.owl-banner');
    owl.owlCarousel({
      margin: 30,
      // center: true,
      items: 1,  
      nav: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:3300,
    })

   // allstore location
    var owlAllstore = $('.owl-allstore-location');
    owlAllstore.owlCarousel({
      margin: 30,
      // center: true,
      nav: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:3300,
      responsive: {
        0: {
          items: 2,
          margin: 20,
        },
        768: {
          items: 3
        },
        992: {
          items: 4
        },
        1200: {
          items: 4  
        }
      }
    })

    // owl-brand1
    var owl = $('.owl-product1');
    owl.owlCarousel({
      margin: 30,
      // center: true,
      nav: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:3300,
      responsive: {
        0: {
          items: 2,
          margin: 20,
        },
        768: {
          items: 3
        },
        992: {
          items: 4
        },
        1200: {
          items: 4  
        }
      }
    })

    // owl-brand2
    var owl = $('.owl-product2');
    owl.owlCarousel({
      margin: 30,
      // center: true,
      nav: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:3300,
      responsive: {
        0: {
          items: 2,
          margin: 20,
        },
        768: {
          items: 3
        },
        992: {
          items: 4
        },
        1200: {
          items: 4  
        }
      }
    })

    // owl-clients
    var owl = $('.owl-brand');
    owl.owlCarousel({
      margin: 30,
      // center: true,
      nav: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:5300,
      responsive: {
        0: {
          items: 2,
          margin: 20,
        },
        576: {
          items: 3
        },
        992: {
          items: 4
        },
        1200: {
          items: 5  
        }
      }
    })

    // owl-carousel3
    var owl = $('.owl-Customer');
    owl.owlCarousel({
      margin: 140,  
      center: true,
      nav: false,
      dots: true,
      loop: true,
      autoWidth:true,
      // autoplay:true,
      autoplayTimeout:3300,
      responsive: {
        0: {
          items: 1,
        },
        200: {
          items: 1,
          autoWidth:false,
          center: false,
        },
        769: {
          items: 1,
          margin: 20,  
        },
        1000: {
          items: 2,
        }
      }
    })

    // owl-clients
    var owl = $('.owl-Where');
    owl.owlCarousel({
      margin: 30,
      // center: true,
      nav: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:3300,
      responsive: {
        0: {
          items: 2,
          margin: 20,
        },
        600: {
          items: 2
        },
        868: {
          items: 3
        },
        1000: {
          items: 5  
        }
      }
    })

    // owl-clients
    var owl = $('.owl-Dummy-Location');
    owl.owlCarousel({
      margin: 5,
      // center: true,
      nav: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:5300,
      responsive: {
        0: {
          items: 2,
          margin: 5,
        },
        576: {
          items: 3
        },
        992: {
          items: 3
        },
        1200: {
          items: 4  
        }
      }
    })
  
    if($(".shopify-policy__container")){
       $(".shopify-policy__container").addClass("container");
    }

    // menu accordions
    $('.open-btns').click(function() {
        $('.navbar-backdrop').addClass('d-block');
    });
    $('.close-btns').click(function() {
        $('.navbar-backdrop').removeClass('d-block');
        $('.navbar-backdrop').addClass('d-none');
    });
    // When any child accordion is clicked
    // $('.card .collapse').on('show.bs.collapse', function () {
    //   // Find sibling .collapse in the same parent .card-body and hide them
    //   $(this).closest('.card-body').find('.collapse.show').not(this).collapse('hide');
    // });
  
    // navbar scroll
    $(document).scroll(function () {
      var scroll = $(this).scrollTop();
      // var topDist = $(".Brews-Kratom-lyte-sec").position();
      if (scroll >  400) {
          $('.navs').addClass("navs-top");
          $('.scroll-tops').addClass("scroll-top");
      } else {
        $('.navs').removeClass("navs-top");
        $('.scroll-tops').removeClass("scroll-top");
      }
    });ter

    $(document).scroll(function () {
      var scroll = $(this).scrollTop();
      if (scroll > 400) {
          $('.scroll-tops').addClass("scroll-top");
      } else {
        $('.scroll-tops').removeClass("scroll-top");
      }
    });

    // top scroll
    $('#top').click(function () {
      $('body,html').animate({
          scrollTop: 0
      }, 2000);
    });
  })

document.addEventListener("DOMContentLoaded", function () {
   if(document.querySelector(".short-description")){
    const description = document.querySelector(".short-description");
    const paragraphs = description.querySelectorAll("p strong");
    paragraphs.forEach(strong => {
      if (strong.textContent.includes("Key Features")) {
        const ul = strong.parentElement.nextElementSibling;
        strong.style.cursor = "pointer";
        strong.addEventListener("click", function () {
          strong.classList.toggle("open");
          ul.classList.toggle("open");
        });
      }
    });
   } 

  if(document.querySelectorAll(".Accordion_item")){
    const accordionItems = document.querySelectorAll(".Accordion_item");
      accordionItems.forEach((item) => {
        const title = item.querySelector(".title_tab");

        title.addEventListener("click", function () {
          const isOpen = item.classList.contains("active");

          // Close all accordions
          accordionItems.forEach((el) => {
            el.classList.remove("active");
            el.querySelector(".inner_content").style.display = "none";
          });

          // If not open already, open the clicked one
          if (!isOpen) {
            item.classList.add("active");
            item.querySelector(".inner_content").style.display = "block";
          }
        });
      });
  }
});